import {
    CASE_ACTION_RUN_REQUESTED_DISPANSE,
    CASE_ACTION_RUN_PROCESSING_DISPANSE,
    CASE_ACTION_RUN_SUCCESSED_DISPANSE,
    CASE_ACTION_RUN_FAILED_DISPANSE,
    CLEAR_ACTION_RUN_REQUESTED_DISPANSE
  } from '../../constants/actionTypes';
  
  const initialState = {
    result: {},
    isProcessing: null,
    isSuccess: null,
    hasErrors: null,
    containerList: {},
    casesDesposition: {},
    casesCategories: {}
  };
  
  export const caseRunActionDispanse = (state = initialState, action) => {
    switch (action.type) {
      case CASE_ACTION_RUN_REQUESTED_DISPANSE: {
        return {
          ...state,
          error: null,
          loading: true,
          isSuccess:false,
          requested: true,
        };
      }
      case CASE_ACTION_RUN_PROCESSING_DISPANSE: {
        return {
          ...state,
          error: null,
          loading: true,
          isSuccess:false,
          requested: false,
        };
      }
      case CASE_ACTION_RUN_SUCCESSED_DISPANSE: {
        return {
          ...state,
          result: action.data,
          error: null,
          loading: false,
          isSuccess:true,
          requested: false,
        };
      }
      case CASE_ACTION_RUN_FAILED_DISPANSE: {
        return {
          ...state,
          result: {},
          error: action.data,
          loading: false,
          isSuccess:false,
          requested: false,
        };
      }
      case CLEAR_ACTION_RUN_REQUESTED_DISPANSE:{
        return {
          result: {},
          isProcessing: null,
          isSuccess: null,
          hasErrors: null,
        };
      }
   
  
     
      
  
  
      default: {
        return {
          ...state,
        };
      }
    }
  };
  
  export default caseRunActionDispanse;
  